/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ForumAttachmentArticle.vue?vue&type=template&id=1f21f41e&scoped=true&"
import script from "./ForumAttachmentArticle.vue?vue&type=script&setup=true&lang=js&"
export * from "./ForumAttachmentArticle.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./ForumAttachmentArticle.vue?vue&type=style&index=0&id=1f21f41e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f21f41e",
  null
  
)

export default component.exports